import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/users/:userId/warehouses`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const warehouses = {
  getAll: apiPathFunc(pathBase),
};
